import { HOURS_PER_DAY, SECONDS_PER_MINUTE } from '@saviynt/common';

export const SECONDS_IN_FIVE_MINUTES = SECONDS_PER_MINUTE * 5;
export const HOURS_IN_THREE_DAYS = HOURS_PER_DAY * 3;
